<script lang="ts" setup>
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'

interface Props {
  image: CarDetailsImage
}

const props = defineProps<Props>()
const { locale } = useI18n()

const label = computed(() => {
  const dedicatedLabels = props.image.description.dedicated ?? {}
  const DEFAULT_LOCALE = 'en'

  return (
    dedicatedLabels[locale.value]
    || dedicatedLabels[DEFAULT_LOCALE]
    || props.image.description.categoryLabel
    || ''
  )
})

const isTranslated = computed(() => {
  if (locale.value === 'de') {
    return false
  }

  return Boolean(props.image.description.dedicated?.en?.length)
})
</script>

<template>
  <p v-if="label">
    {{ label }}

    <span v-if="isTranslated" class="block text-xs italic">
      {{ $t('car-details.please-note-this-text-was-translated-by-machinge') }}
    </span>
  </p>
</template>
